module.exports = __webpack_public_path__ + "static/media/sdmt8.73723860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt8.svg
// module id = 348
// module chunks = 0